import React from 'react';

import type { SVGProps } from '@atlaskit/icon/svg';
import SVG from '@atlaskit/icon/svg';

export const RecentIcon = (props: SVGProps) => (
	<SVG {...props}>
		<rect width="24" height="24" fill="none" fillOpacity="0.01" />
		<g xmlns="http://www.w3.org/2000/svg">
			<path
				id="Combined Shape"
				d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM12 7L12.1166 7.00671C12.6139 7.06448 13 7.48716 13 8V11H16L16.1166 11.0067C16.6139 11.0645 17 11.4872 17 12C17 12.5523 16.5523 13 16 13H12L11.8834 12.9933C11.3861 12.9355 11 12.5128 11 12V8L11.0067 7.88336C11.0645 7.38602 11.4872 7 12 7Z"
				fill="currentColor"
			/>
		</g>
	</SVG>
);
